// GS1 Application Identifier (https://ref.gs1.org/ai/90)
const APPLICATION_IDENTIFIER = '90';

const CONTAINER_SEPARATOR = '-';

/**
 * Extract article ID from barcode information which contains article id and container id.
 * @param barcodeData string stored in barcode
 */
export function parseBarcodeData(barcodeData: string): string | null {
  if (!barcodeData.startsWith(APPLICATION_IDENTIFIER)) {
    return null;
  }

  const articleContainerId = barcodeData.slice(APPLICATION_IDENTIFIER.length);
  const [articleId] = articleContainerId.split(CONTAINER_SEPARATOR);

  return articleId;
}
